<template>
<div class="main">
  <div class="learn">
    <div class="container">
      <div class="text-center">
        <h1>事業計画書のキホン</h1>
        <p>事業計画書を書くときに知っておきたい基礎知識です。</p>
      </div>
      <div class="learn-index">
        <div v-for="item in learnItems"
          class="learn-item">
          <router-link v-bind:to="{name: 'learnDetail', params: {learnId: item.id}}">
            <div class="learn-item-inner">
              <div class="thumbnail">
                <img :src="item.thumbnail"
                  :alt="item.title">
              </div>
              <div class="text">
                <h2 class="title">{{ item.title }}</h2>
                <!-- <div class="description">
                {{ item.description }}
              </div> -->
              </div>
            </div>
          </router-link>
        </div>
      </div>
      <div class="text-center">
        <router-link v-bind:to="{name: 'home'}">
          <Button>トップへ戻る</Button>
        </router-link>
      </div>
    </div>
  </div>
</div>
</template>

<script>
//const axios = require('axios')
import learnItemIndex from '@/assets/learn/index'
export default {
  data() {
    return {}
  },
  computed: {
    learnItems: function () {
      return learnItemIndex
    }
  },
  mounted: function () {},
  methods: {}
}
</script>
